<template lang="pug">
  div
    h2 {{ $t('requestDetailedOffer') }}
    p.description
      | {{ $t('requestDetailedOfferDescription') }}
    ValidationObserver(v-slot="{ passes }")
      form(@submit.stop.prevent="passes(onSubmit)" novalidate)
        .row
          .col-sm-6
            ValidationProvider(
              :name="$t('insuranceStartDate')"
              rules="required"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('insuranceStartDate') }}
                input(type="date"
                  v-model="contactInfos.insuranceStartDate").pf-input
                .pf-error {{ errors[0] }}
          .col-sm-6
            ValidationProvider(
              :name="$t('insuranceContractDuration')"
              rules="required"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('insuranceContractDuration') }}
                select.pf-select(
                  v-model="contactInfos.insuranceContractDuration")
                  option(v-for="insuranceContractDuration in insuranceContractDurationOptions"
                    v-bind:value="insuranceContractDuration") {{ insuranceContractDuration }}
                .pf-error {{ errors[0] }}
        .row
          .col-sm-6
            ValidationProvider(
              :name="$t('petName')"
              rules="required"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('petName') }}
                input(type="text"
                  v-model="contactInfos.petName").pf-input
                .pf-error {{ errors[0] }}
          .col-sm-6
            ValidationProvider(
              :name="$t('race')"
              rules="required"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('race') }}
                input(type="text"
                  v-model="contactInfos.race").pf-input
                .pf-error {{ errors[0] }}
        hr
        .row
          .col-sm-6
            ValidationProvider(
              :name="$t('gender')"
              rules="required"
              v-slot="{ errors }")
              label.pf-label {{ $t('gender') }}
              .gender-selection
                .pf-form-group(v-for="(gender, index) in genders")
                  .pf-radio-group.pf-basic-radio
                    input(:id="'gender-'+index"
                      type="radio"
                      :value="gender.value"
                      v-model="contactInfos.gender")
                    label(:for="'gender-'+index") {{ gender.label }}
                .pf-error {{ errors[0] }}
        .row
          .col-sm-6
            ValidationProvider(
              :name="$t('firstName')"
              rules="required"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('firstName') }}
                input(type="text"
                  v-model="contactInfos.firstName").pf-input
                .pf-error {{ errors[0] }}
          .col-sm-6
            ValidationProvider(
              :name="$t('lastName')"
              rules="required"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('lastName') }}
                input(type="text"
                  v-model="contactInfos.lastName").pf-input
                .pf-error {{ errors[0] }}
          .col-sm-6
            .row
              .col-sm-6
                ValidationProvider(
                  :name="$t('street')"
                  rules="required"
                  v-slot="{ errors }")
                  .pf-form-group
                    label.pf-label {{ $t('street') }}
                    input(type="text"
                      v-model="contactInfos.street").pf-input
                    .pf-error {{ errors[0] }}
              .col-sm-6
                ValidationProvider(
                  :name="$t('number')"
                  rules="required"
                  v-slot="{ errors }")
                  .pf-form-group
                    label.pf-label {{ $t('number') }}
                    input(type="text"
                      v-model="contactInfos.number").pf-input
                    .pf-error {{ errors[0] }}
          .col-sm-6
            .row
              .col-sm-6
                ValidationProvider(
                  :name="$t('postCode')"
                  rules="required"
                  v-slot="{ errors }")
                  .pf-form-group
                    label.pf-label {{ $t('postCode') }}
                    input(type="number"
                      v-model="contactInfos.postCode").pf-input
                    .pf-error {{ errors[0] }}
              .col-sm-6
                ValidationProvider(
                  :name="$t('region')"
                  rules="required"
                  v-slot="{ errors }")
                  .pf-form-group
                    label.pf-label {{ $t('region') }}
                    input(type="text"
                      v-model="contactInfos.region").pf-input
                    .pf-error {{ errors[0] }}
          .col-sm-6
            ValidationProvider(
              :name="$t('phone')"
              rules="required|integer"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('phone') }}
                input(type="number"
                  v-model="contactInfos.phone").pf-input
                .pf-error {{ errors[0] }}
          .col-sm-6
            ValidationProvider(
              :name="$t('email')"
              rules="required|email"
              v-slot="{ errors }")
              .pf-form-group
                label.pf-label {{ $t('email') }}
                input(type="text"
                  v-model="contactInfos.email").pf-input
                .pf-error {{ errors[0] }}
          .col-sm-6
            BackButton
          .col-sm-6
            button(v-wait:disabled="'Lead Form'"
              type="submit").pf-button
              v-wait(for="Lead Form")
                template(slot="waiting")
                  pulse-loader(color="white" size="8px")
                | {{ $t('send') }}
    template(v-for="note in subnote[locale]")
      p.pf-subnote {{ note }}
</template>

<script>
import {
  AGE_GROUPS, APP_IDS, INSURANCE_CONTRACT_YEARS, CIVIL_STATUSES,
} from '@/support/constants';
import de from 'vuejs-datepicker/dist/locale/translations/de';
import { mapState } from 'vuex';
import LeadApiService from '../../services/lead-api.service';
import BackButton from './BackButton.vue';

export default {
  name: 'SaveLeadForm',
  data() {
    return {
      contactInfos: {
        insuranceStartDate: '',
        insuranceContractDuration: 1,
        petName: '',
        race: '',
        gender: '',
        firstName: '',
        lastName: '',
        street: '',
        number: '',
        postCode: '',
        region: '',
        phone: '',
        email: '',
      },
      insuranceCompanies: [],
      offerChoices: window.layoutoneOfferChoices,
      genders: [
        {
          value: 'M',
          label: this.$t('male'),
        },
        {
          value: 'F',
          label: this.$t('female'),
        },
      ],
      ageGroups: AGE_GROUPS,
      subnote: window.layoutoneNote,
      german: de,
      insuranceContractDurationOptions: INSURANCE_CONTRACT_YEARS,
      civilStatusOptions: CIVIL_STATUSES,
      countryOptions: [],
    };
  },
  components: { BackButton },
  computed: {
    ...mapState({
      userInfos: (state) => state.userInfos,
      insuranceInfos: (state) => state.insuranceInfos,
      persons: (state) => state.persons,
      postCode: (state) => state.postCode,
    }),
  },
  mounted() {
    this.contactInfos.birthDate = this.userInfos.birthDate || '';
    this.contactInfos.insuranceStartDate = this.userInfos.startOfInsurance || '';
  },
  methods: {
    onSubmit() {
      this.$wait.start('Lead Form');
      const { leadPreference } = window;
      switch (leadPreference) {
        case 'email':
          this.sendEmail();
          break;
        case 'crm':
          this.sendCRMRequest();
          break;
        default:
      }
    },
    sendEmail() {
      const loginData = `grant_type=client_credentials&scope=sender-360-api&client_id=${window.clientId}&client_secret=${window.clientSecret}`;
      LeadApiService.loginRequest(loginData).then((response) => {
        const leadToken = response.data.access_token;
        const mailData = {
          ...{ contactInfos: this.contactInfos },
          ...this.userInfos,
          ...{ insuranceInfos: this.insuranceInfos },
        };

        mailData.persons = this.persons;

        const mailObject = {
          CalculatorId: APP_IDS.calculatorId,
          Template: 2,
          To: [window.emailAddress],
          CC: [],
          BCC: [],
          Body: LeadApiService.convertLeadDataTemplate2(mailData),
          RemoveBodyAfterSent: true,
        };
        LeadApiService.sendMail(mailObject, leadToken)
        // eslint-disable-next-line no-shadow
          .then((response) => {
            if (response) {
              this.$router.push({ name: 'Result' });
            }
          }).finally(() => {
            this.$wait.end('Lead Form');
          });
      });
    },
    sendCRMRequest() {
      const loginData = `grant_type=client_credentials&scope=sender-360-api&client_id=${window.clientId}&client_secret=${window.clientSecret}`;
      LeadApiService.loginRequest(loginData).then((response) => {
        const leadToken = response.data.access_token;
        const mailData = {
          ...this.contactInfos,
          ...this.userInfos,
          ...this.insuranceInfos,
        };
        LeadApiService.sendCRMRecord(LeadApiService.convertLeadData(mailData), leadToken)
        // eslint-disable-next-line no-shadow
          .then((response) => {
            if (response) {
              this.$router.push({ name: 'Result' });
            }
          }).finally(() => {
            this.$wait.end('Lead Form');
          });
      });
    },
  },
};
</script>
